import { postDict } from "../api/api";
import { chooseObj, datePickerObj, inputObj, pickerObj } from "utils/getObjs";

const basicInformation = [
  {
    ...inputObj('姓名', "FNAME", true, true),
    valueDisabled: true,//是否有值后不可填
  },
  inputObj('证件号码', "FIDNUM", true, true),
  inputObj('性别', "FSEX", true, true),
  inputObj('手机号码', "FPHONUM", true),
  datePickerObj('出生日期', 'FBIRTH', true),
  inputObj('身高CM', 'FHeight'),
  inputObj('视力', 'FVision'),
  pickerObj('外语水平', 'FLanguageLevel'),
  pickerObj('计算机水平', 'FComputerSkill'),
  pickerObj('驾照类型', 'FLicenseType'),
  pickerObj('户口性质', 'FRegiPerm', true),
  datePickerObj('登记日期', 'FDay', true, true),
  {
    ...chooseObj('求职登记地类型', 'FjobPlaceType', true),
    option: [[
      { label: '户籍地址', value: 1 },
      { label: '常住地址', value: 2 }
    ]]
  },
  pickerObj('户籍地址', 'permanent118', true, true),
  inputObj('户籍详细地址', 'FResidDeta', true),
  pickerObj('常住地址', 'address118', true, true),
  inputObj('常住详细地址', 'FPerDeta', true),
  datePickerObj('参加工作时间', 'FWORKTIME', true),
  inputObj('电子邮箱', 'FEMAIL'),
  {
    ...chooseObj('求职状态', 'FJOBSTATUS', true),
    option: [[
      { label: '在职-月内到岗', value: 1 },
      { label: '离职-随时到岗', value: 2 },
      { label: '在职-考虑机会', value: 3 },
      { label: '在职-暂不考虑机会', value: 4 }
    ]]
  },
];

// 自我介绍
const selfIntroduction = [
  {
    ...inputObj('自我介绍', 'FINTRMYSELF'),
    maxLength: 100
  }
]

// 求职意向
const careerObjective = [
  {
    infoType: 'manyCascade',
    tableName: 'FOBJECTIVE',
    label: '求职',
    pickerTitle: '请选择',
    option: [
      pickerObj('意向岗位', 'FINTEJOB'),
      pickerObj('求职意向地', 'place'),
      pickerObj('期望薪资', 'FEXPSALARY'),
    ],
    message: '请选择等级',
    required: false,
    disabled: false,
    placeholder: '请选择',
    api: postDict,
    count: [0, 1, 2],
  },
]

// 工作经历
const workExperience = [
  {
    infoType: 'manyCascade',
    tableName: 'FWORKEXPER',
    label: '工作经历',
    pickerTitle: '请选择',
    option: [
      datePickerObj('工作时间起', 'FFRWOHOUR'),
      datePickerObj('工作时间止', 'FENWOHOUR'),
      inputObj('公司名称', 'FCOMNAME'),
      inputObj('职位名称', 'FJOBTITLE'),
      inputObj('工作介绍', 'FWOINTRO'),
    ],
    message: '请选择等级',
    required: false,
    disabled: false,
    placeholder: '请选择',
    api: postDict,
    count: [0, 1, 2],
  },
]

/** 教育经历 */
const eduExperience = [
  {
    infoType: 'manyCascade',
    tableName: 'FEDUEXPER',
    label: '教育经历',
    pickerTitle: '请选择',
    option: [
      datePickerObj('在校时间起', 'FFOSCHHOUR'),
      datePickerObj('在校时间止', 'FEnSchHou'),
      inputObj('学校名称', 'FSCHNAME'),
      pickerObj('学历', 'FEDUBACK'),
      {
        ...chooseObj('是否统招', 'FUNIFMO', true),
        option: [[
          { label: '统招', value: 1 },
          { label: '非统招', value: 2 },
        ]]
      },
      pickerObj('所学专业', 'FPROTITLE'),
    ],
    message: '请选择等级',
    required: false,
    disabled: false,
    placeholder: '请选择',
    api: postDict,
    count: [0, 1, 2],
  },
]

const certificate = [
  {
    infoType: 'manyCascade',
    tableName: 'FCERTIFICATE',
    label: '证书',
    pickerTitle: '请选择',
    option: [
      inputObj('证书名称', 'FCERTNAME'),
      inputObj('证书编号', 'FCERTNUM'),
    ],
    message: '请选择等级',
    required: false,
    disabled: false,
    placeholder: '请选择',
    api: postDict,
    count: [0, 1, 2],
  },
]

export const seekJobPage1 = [
  { title: '基本信息', arr: basicInformation },
  { title: '自我介绍', arr: selfIntroduction },
  // { title: '求职意向', arr: careerObjective },
  // { title: '工作经历', arr: workExperience },
  // { title: '教育经历', arr: eduExperience },
  // { title: '证书', arr: certificate }
]
export const seekJobPage2 = [
  { title: '求职意向', arr: careerObjective }
]
export const seekJobPage3 = [
  { title: '工作经历', arr: workExperience },
  { title: '教育经历', arr: eduExperience },
  { title: '证书', arr: certificate }
]
